import type { SiteLocale } from '@/lib/i18n/locales'
import { localizeInternalHref } from '@/lib/i18n/paths'
import { getUiDictionary } from '@/lib/i18n/ui'

export type BaseNavItem = {
  href: string
  label: string
}

export function getBaseNavItems(locale: SiteLocale): BaseNavItem[] {
  const t = getUiDictionary(locale)
  return [
    { href: localizeInternalHref('/servicios', locale), label: t.nav.services },
    { href: localizeInternalHref('/contacto', locale), label: t.nav.contact },
  ]
}

export function getGuestNavItems(locale: SiteLocale): BaseNavItem[] {
  const t = getUiDictionary(locale)
  return [
    { href: localizeInternalHref('/inicio-sesion', locale), label: t.nav.signIn },
    { href: localizeInternalHref('/registrarse', locale), label: t.nav.register },
  ]
}

export const desktopNavLinkClass =
  'inline-flex items-center rounded-md px-4 py-2 text-sm font-semibold text-gray-100 transition-colors duration-150 hover:bg-cream-600 hover:text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cream-300 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-950'

export const desktopPrimaryLinkClass =
  'inline-flex items-center rounded-md bg-cream-600 px-4 py-2 text-sm font-semibold text-gray-900 shadow-md transition-colors duration-150 hover:bg-cream-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cream-300 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-950'

export const desktopGhostButtonClass =
  'inline-flex items-center rounded-md border border-gray-600 px-4 py-2 text-sm font-semibold text-gray-100 transition-colors duration-150 hover:border-cream-400 hover:text-cream-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cream-300 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-950'

export const mobileNavLinkClass =
  'block w-full rounded-md px-4 py-3 text-center text-base font-medium text-gray-100 transition-colors duration-150 hover:bg-cream-600 hover:text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cream-300 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900'

export const mobilePrimaryLinkClass =
  'inline-flex w-full items-center justify-center rounded-md bg-cream-600 px-4 py-3 text-base font-semibold text-gray-900 transition-colors duration-150 hover:bg-cream-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cream-300 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900'

export const mobileGhostButtonClass =
  'inline-flex w-full items-center justify-center rounded-md border border-gray-500 px-4 py-3 text-base font-semibold text-gray-100 transition-colors duration-150 hover:border-cream-400 hover:text-cream-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cream-300 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900'
